// Core Modules
import React, { Component } from 'react';
// Components
import Sidebar from '../../components/Sidebar/Sidebar';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ExamsList from '../../components/ExamsList/ExamsList';
// Styles
import '../assets/css/material-dashboard.css';
// Depandancy Modules
import * as firebase from 'firebase/app';
import 'firebase/auth';
import swal from 'sweetalert';
import RingLoader from "react-spinners/RingLoader";
import axios from 'axios';

class Assignments extends Component {
    
    state = { 
        isLoading: true,
        examsContent: null
    }

    componentDidMount = () => {
        if (!!document.getElementsByClassName('nav-open')[0]) {
            document.getElementsByClassName('nav-open')[0].classList.remove('nav-open');
        }
        let cachedData = sessionStorage.getItem('auth_data');
        if (!!cachedData) {
            let authData = JSON.parse(cachedData);
            let postUrl = 'https://us-central1-insightplus-mpm.cloudfunctions.net/app/web/v1/getexams';
            axios.post(postUrl, {
                username: authData.username,
                password: authData.password
            }).then((response) => {
                if (response.status === 200) {
                    this.setState({examsContent: response.data.data, isLoading: false});
                }else if (response.status === 500) { 
                    swal("", response.message, "error");
                    this.setState({isLoading: false});
                }else {
                    this.setState({isLoading: false});
                }              
            }).catch((err) => {
                this.setState({isLoading: false}, () => {
                    swal("Error", err.message, "error");
                });
            });
        } else {
            swal("", "Session Expired", "warning").then(() => {
                firebase.auth().signOut()
                .then(() => {
                    sessionStorage.setItem('auth_data', '');
                    window.location.pathname = '/';
                });
            });
        }
    }
    
    render() { 
        return ( 
            <div className="wrapper ">
                <Sidebar />
                <div className="main-panel">
                    <Navbar />
                    <div className="content">
                        <div className="container-fluid">
                            <RingLoader
                                css={{display: 'block', margin: '25vh auto',borderColor: 'red'}}
                                size={150}
                                color={"#262222"}
                                loading={this.state.isLoading} />
                            {
                                !!this.state.examsContent ? 
                                    <ExamsList loading={this.state.isLoading} data={this.state.examsContent}/> 
                                : this.state.isLoading ? null : <h3>There is No Exams As of Now</h3>
                            }
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}
 
export default Assignments;